import React, { useEffect } from 'react';
import { Typography } from '@mui/material';

import { useAppDispatch } from '../../state/hooks';
import AuthService from '../../services/authService';
import OverlaySpinner from '../../components/Loaders/OverlaySpinner';

const Revoke = (): React.JSX.Element => {
    const dispatch = useAppDispatch();

    useEffect((): void => {
        AuthService.completeLogout();
    }, [dispatch]);

    return (
        <OverlaySpinner noBackground>
            <Typography variant='subtitle2'>
                Logging Out...
            </Typography>
        </OverlaySpinner>
    );
};

export default Revoke;
